// Shared risk metadata / mappings

export const LEVEL_META = {
  BAIXO: { color: "#2A9D8F", bg: "#E9F5F4", border: "#BFE3DF" },
  MEDIO: { color: "#B98A00", bg: "#FBF7ED", border: "#EAD9A8" },
  ALTO: { color: "#E76F51", bg: "#FDF0EA", border: "#F6CDBF" },
  CRITICO: { color: "#D62828", bg: "#FBEAEA", border: "#F2C2C2" },
};

export const RISK_META = {
  LOW: { color: "#2A9D8F", bg: "#E9F5F4", label: "BAIXO", labelEn: "LOW" },
  MEDIUM: { color: "#B98A00", bg: "#FBF7ED", label: "MÉDIO", labelEn: "MEDIUM" },
  HIGH: { color: "#E76F51", bg: "#FDF0EA", label: "ALTO", labelEn: "HIGH" },
  CRITICAL: { color: "#D62828", bg: "#FBEAEA", label: "CRÍTICO", labelEn: "CRITICAL" },
};

export const TYPE_LABEL = {
  PROMPT_INJECTION: { pt: "Possível Prompt Injection", en: "Possible Prompt Injection" },
  INVISIBLE_TEXT: { pt: "Texto quase invisível", en: "Nearly invisible text" },
  SUSPICIOUS_COLOR: { pt: "Cor suspeita", en: "Suspicious color" },
  HIDDEN_CONTENT: { pt: "Conteúdo oculto", en: "Hidden content" },
  INVISIBLE_CHARS: { pt: "Caracteres invisíveis", en: "Invisible characters" },
  FONT_CHANGE: { pt: "Mudança de fonte", en: "Font change" },
  METADATA: { pt: "Inconsistência de metadados", en: "Metadata inconsistency" },
};

export function levelFromScore(score) {
  if (score <= 24) return "BAIXO";
  if (score <= 49) return "MEDIO";
  if (score <= 74) return "ALTO";
  return "CRITICO";
}
